import applyIoStudioSlateConfig from '@redturtle/volto-io-studio/config/Slate/config';
import applyIOStudioBlocksConfig from '@redturtle/volto-io-studio/config/Blocks/blocks';
import {
  facultyItemsReducer,
  replicaItemsReducer,
  unitItemsReducer,
} from './reducers';
import { Search } from '@plone/volto/components';
import { SubsiteLoader } from 'volto-subsites';
import { Replica, ReplicaMenu } from './components';
import { Sitemap } from '@plone/volto/components';
import { SubsiteSocialLinksWidget } from './components/Widgets';
import { AvvisoView } from './components/View';

const applyConfig = (config) => {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['it', 'en'];
  config.settings.defaultLanguage = 'it';
  config.settings.navDepth = 2;
  config.settings.showTags = false;

  config.settings.defaultExcludedFromSearch = {
    portalTypes: ['Image', 'File'],
  };

  config.settings['volto-site-settings'].logo_height = 58;

  // ROUTES
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/**/search',
      component: Search,
    },
    {
      path: '/**/@replica',
      component: Replica,
    },
    // TODO: PR su @plone/volto per sitemap nei subsites
    {
      path: '/**/sitemap',
      component: Sitemap,
    },
  ];

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    '/@replica',
    /\/sitemap$/,
  ];

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: SubsiteLoader,
    },
    {
      match: '',
      component: ReplicaMenu,
    },
  ];

  config.addonReducers = {
    ...config.addonReducers,
    facultyItems: facultyItemsReducer,
    unitItems: unitItemsReducer,
    replicaItems: replicaItemsReducer,
  };

  // widgets
  config.widgets.id = {
    ...config.widgets.id,
    subsite_social_links: SubsiteSocialLinksWidget,
  };

  // views
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Avviso: AvvisoView,
    'News Item': AvvisoView,
  };

  applyIoStudioSlateConfig(config);
  applyIOStudioBlocksConfig(config);
  return config;
};

export default applyConfig;
